import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-team-results',
    templateUrl: './team-results.component.html',
    styleUrls: ['./team-results.component.scss'],
})
export class TeamResultsComponent {
    @Input() games: any[] = [];
    @Input() participantes: any = {};

    getWinner1(resultado: any): boolean {
        return Number(resultado.resultado_1) > Number(resultado.resultado_2);
    }

    getWinner2(resultado: any): boolean {
        return Number(resultado.resultado_2) > Number(resultado.resultado_1);
    }
}
